export const THEME_COLORS = {
  AZUL_OSCURO: "#142850",
  AZUL: "#27496D",
  CELESTE: "#00909E",
  GRIS: "#DAE1E7",
  NARANJA: "#E16726",
};

export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const HASH_TOKEN = "hashToken";
export const USER = "user";
export const EMAIL = "email";
export const USERID = "userid";
export const DISPLAYNAME = "displayName";
export const ENTERPRISE = "Trimealo";
export const FLIGHTSCHOOLID = "flightSchoolId";
export const IMAGE = "image";
export const ACCESS = "access";
export const USERNAME = "userName";
export const ACCOUNTS = "accounts";
export const TOKEN_NOTIFICATION = "tokenNotification";

export const BACKEND_USER = { _id: "00000002", roles: ["user"] };

export const ACTION_BUTTONS = {
  EDIT: "edit",
  EMAIL: "email",
  WHATSAPP: "whatsApp",
  PHONECALL: "phoneCall",
  FOLLOWUP: "followUp",
  NEWTASK: "newTask",
  DELETE: "delete",
  CANCEL: "cancel",
  DOWNLOAD: "download",
  DESVINCULATE: "desvinculate",
  VIEW: "view",
  VINCULATE: "vinculate",
  SENDBYEMAIL: "sendByEmail",
  SEEDETAIL: "seeDetail",
  OPENDOCUMENT: "openDocument",
  APPROVEOPPORTUNITY: "approveOpportunity",
  PAY: "pay",
};

export const KEY_GOOGLE_MAPS = "AIzaSyBfj-EamuPH8aYtoQBU24BXDq357H5KRBU";

export const EMAIL_SUPPPORT = "csrservices@potholerepair.com";

export const KEY_NOTIFICATION_FIREBASE =
  "BMwiMHziySooKDHBaGyEBESnn8mf-g5KR7N95pDgtxHtrn68sCHTbh9WLgRA1YxaA6JfaWS8aorV87OQ6wDvptc";

export const URL_INTERACTIVE_CALCULATOR =
  "https://interactivereport.potholerepair.com/calculator";

export const URL_INTERACTIVE_CALCULATOR_TEST =
  "https://testing.interactivereport.potholerepair.com/calculator";
